import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async show(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/customers/${id}`, { params: payload });

        return response.data.data;
    },

    async update(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.put(`v1/customers/${id}`, payload);

        return response.data.data;
    },

    async associatedleads(customerId) {
        if (!customerId) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/customers/${customerId}/associatedLeads`);

        return response.data.data;
    },

    async vehicles(customerId, payload = {}) {
        if (!customerId) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/customers/${customerId}/vehicles`, { params: payload });

        return response.data.data;
    },

    async vehicle(customerId, vehicleId, payload = {}) {
        if (!customerId || !vehicleId) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/customers/${customerId}/vehicles/${vehicleId}`, { params: payload });

        return response.data.data;
    },
};
